export const getLanguage = () => {
  try {
    return localStorage.getItem('sc_site-language')
  } catch (e) {
    return document.getElementById('HybrisSelfCareB2CComponentLanguage').value
  }
}
